function blackVipListOnload() {

    const topBar = document.getElementById('topBar');

    $(window).on('scroll', function () {
        const scroll = $(this).scrollTop();

        //paralax
        $('.ev_header_background').css(
            'transform',
            `translateY(${scroll * 0.3}px)`
        );

        // Progress bar
        const total = document.body.scrollHeight - window.innerHeight;
        const pct = (window.scrollY / total) * 100;
        topBar.style.width = pct + '%';

        $('.carousel').slick({
            dots: true,
            infinite: false,
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            fade: true,
            cssEase: 'linear'
        });

    });


    // Prazo final: 15/09/2026, 23h59 (horário de Brasília, UTC-3)
    var deadline = new Date("2026-11-18T23:59:00-00:00").getTime();

    function pad(n){
        return String(n).padStart(2,"0");
    }

    function tick(){
        var now = new Date().getTime();
        var diff = deadline - now;

        // Seleciona todos os blocos de contadores da página
        var banners = document.querySelectorAll(".countdown-banner");

        if (diff <= 0){
            banners.forEach(function(banner) {
                banner.querySelector(".cd-d").textContent = "0";
                banner.querySelector(".cd-h").textContent = "00";
                banner.querySelector(".cd-m").textContent = "00";
                banner.querySelector(".cd-s").textContent = "00";
            });
            clearInterval(timer);
            return;
        }

        var d = Math.floor(diff / (1000*60*60*24));
        var h = Math.floor((diff % (1000*60*60*24)) / (1000*60*60));
        var m = Math.floor((diff % (1000*60*60)) / (1000*60));
        var s = Math.floor((diff % (1000*60)) / 1000);

        // Atualiza cada um dos contadores encontrados
        banners.forEach(function(banner) {
            banner.querySelector(".cd-d").textContent = d;
            banner.querySelector(".cd-h").textContent = pad(h);
            banner.querySelector(".cd-m").textContent = pad(m);
            banner.querySelector(".cd-s").textContent = pad(s);
        });
    }

    tick();
    var timer = setInterval(tick, 1000);

    //form
    selectStateCity('state','city');
}